<template>
  <div id="ypsdk" ref="ypbox" v-if="show">
    <!-- 云片SDK -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  methods: {
    // 云片验证
    yunpian() {
      this.show = true;
      return new Promise((resolve, reject) => {
        // YpRiddler是一个全局函数
        this.$nextTick(() => {
          this._yp = new window.YpRiddler({
            onSuccess(validInfo, close, useDefaultSuccess) {
              resolve(validInfo);
              useDefaultSuccess(true);
              close();
            },
            appId: "3965ffed8df64eef9e49d496e79455e5",
            version: "v1",
            container: this.$refs.ypbox,
            winWidth: 350,
            onError: function(param) {
              reject(param);
            },
            onFail: function(code, msg, retry) {
              // 失败回调
              retry();
            }
          });
          // 模拟触发click事件
          if (this._yp.CONTAINER.click) {
            this._yp.CONTAINER.click();
          }
        });
      });
    },

    ready() {
      return this.yunpian().then(
        validInfo => {
          this.show = false;
          this.openMessage(1, '图形验证成功');
          return validInfo;
        },
        param => {
          if (!param.code) {
            this.openMessage(0, "错误请求");
          } else if (parseInt(param.code / 100) == 5) {
            // 服务不可用时，开发者可采取替代方案
            this.openMessage(0, "验证服务暂不可用");
          } else if (param.code == 429) {
            this.openMessage(2, "请求过于频繁，请稍后再试");
          } else if (param.code == 403) {
            this.openMessage(2, "请求受限，请稍后再试");
          } else if (param.code == 400) {
            this.openMessage(2, "非法请求，请检查参数");
          } else {
            this.openMessage(0, "验证服务异常");
          }
          return Promise.reject(param);
        }
      );
    }
  }
};
</script>
